import {useContext} from "react";

import {ProjectContext} from "../../contexts/ProjectContext";
import {CompanyType} from "../../models/company";
import ViewProjectAsDeveloper from "../developer/DeveloperViewProject";
import ViewProjectAsBuilder from "../builder/ViewProjectBuilder";


export default function ViewProjectHomePage() {
    const projectContext = useContext(ProjectContext);
    // console.log(projectContext)
    if(projectContext === null){
        return <div>error</div>
    } else if (projectContext.role === CompanyType.developer) {
        return <ViewProjectAsDeveloper/>
    } else if (projectContext.role === CompanyType.builder) {
        return <ViewProjectAsBuilder/>
    }
    return (<div> err </div>)
}